import React, { lazy, Suspense } from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import ReactTopProgressBar from "react-top-progress-bar"
import { Error404 } from "./Error"
import LoginPage from "./pub/LoginPage"
import HomeRedirector from "./HomeRedirector"
import ForgotPasswdPage from "./pub/ForgotPasswdPage"
import ChangePasswdTokenPage from "./pub/ChangePasswdTokenPage"
import { SearchContextProvider } from "../components/context/SearchContext"

const PublicSessionPageLazy = lazy(() => import("./public/PublicSessionPage"))
const RouterViewLazy = lazy(() => import("./_router_view"))

export default () => {
  return (
    <Router>
      <SearchContextProvider>
        <Suspense fallback={<ReactTopProgressBar value={99.99} striped />}>
          <Routes>
            <Route path="/" element={<HomeRedirector />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/change_passwd/:token" element={<ChangePasswdTokenPage />} />
            <Route path="/forgot_passwd" element={<ForgotPasswdPage />} />
            <Route path="/public/:token" element={<PublicSessionPageLazy />} />
            <Route path="/view/*" element={<RouterViewLazy />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </Suspense>
      </SearchContextProvider>
    </Router>
  )
}
